import { ProposedFtlRoute } from "./ProposedFtlRoute";
import { EditableDateCell } from "./EditableDateCell";
import { RouteState } from "../../../Project/ViewModel/RouteState";
import { LaunchDateCellProps } from "./DateCellProps";
import { useIsUserInRoles } from "../../../Auth/useIsUserInRoles";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";

const LaunchDateCell = ({ gridCellProps, handleDateChange }: LaunchDateCellProps) => {
  const { dataItem } = gridCellProps;
  const proposedFtlRoute = dataItem as ProposedFtlRoute;
  const editable = proposedFtlRoute?.RouteState !== RouteState.Launched;

  const isUserInAdminNetworkRole = useIsUserInRoles(AuthorizationPolicies.RequireAdminNetworkRoles);
  return (
    <EditableDateCell
      gridCellProps={gridCellProps}
      handleDatePickerChange={handleDateChange}
      editable={(editable ?? false) && isUserInAdminNetworkRole}
      highlightValue={false}
      launchDateKey="LaunchDate"
      disabled={!isUserInAdminNetworkRole}
    />
  );
};

export const launchDateCell = ({ gridCellProps, handleDateChange }: LaunchDateCellProps) => {
  return <LaunchDateCell gridCellProps={gridCellProps} handleDateChange={handleDateChange} />;
};
